<template>
    <div class="flashsale_container">
        <div class="top_banner">
            <!-- <div class="top_icon">首页</div> -->
            <div class="top_img">
                <img src="../assets/flashsaleimg/banner.png" alt srcset />
            </div>
        </div>
        <div class="flashsale_main">
            <div class="title_img">
                <img src="../assets/flashsaleimg/title1.png" alt srcset />
            </div>
            <!-- 秒杀主体内容 -->
            <div class="flashsale_main_body">
                <!-- 头部日期切换 -->
                <div class="flashsale_main_body_linear">
                    <!-- 选择日期 -->
                    <ul class="cl date_main">
                        <li
                            v-for="(item,index) in flashSaleData"
                            @click="chooseDate(index)"
                            class="fl date_li"
                            :class="index == curDateIndex?'active':''"
                        >{{item.date}}</li>
                    </ul>
                    <!-- 该日期下进行的秒杀活动内容 -->
                    <ul class="model_main">
                        <li v-for="item in flashSaleData[curDateIndex].content" class="model_li">
                            <div class="model_img">
                                <a :href="item.killHref">
                                    <img :src="item.img" alt />
                                </a>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <!-- 领取优惠相关 -->
        <div class="user_coupon">
            <!-- 领取 -->
            <div v-if="canGetCoupon"  @click="getcoupon()">
                <img src="../assets/flashsaleimg/coupon1.png" alt />
            </div>
            <!-- 使用 -->
            <div v-else>
                <a :href="'https://m.hiweixiu.com?ref='+ref+'&active_token='+username+'&active_phone='+phone_number+'#/'">
                    <img src="../assets/flashsaleimg/coupon2.png" alt="">
                </a>
                
            </div>
            
            
            
        </div>
        <!-- 换外屏直降 -->
        <div>
            <div class="title_img">
                <img src="../assets/flashsaleimg/title2.png" alt srcset />
            </div>
            <div class="repair">
                <ul class="repair_mian cl">
                    <li class="repair_li fl" v-for="item in screenData" >
                        <img :src="item.img" alt />
                        <a :href="'https://m.hiweixiu.com?ref='+ref+'&active_token='+username+'&active_phone='+phone_number+'#/detailFault?mid='+ item.id">
                            <div class="repair_li_btn"></div>
                        </a>
                    </li>
                    
                </ul>
                <div class="seemore">
                    <a href="http://m.hiweixiu.com/#/list">
                        <span>查看更多</span>
                    </a>
                </div>
            </div>
        </div>
        <!-- 换电池直降 -->
        <div>
            <div class="title_img">
                <img src="../assets/flashsaleimg/title3.png" alt srcset />
            </div>
            <div class="repair">
                <ul class="repair_mian cl">
                    <li class="repair_li fl" v-for="item in batteryData" >
                        <img :src="item.img" alt />
                        <a :href="'https://m.hiweixiu.com?ref='+ref+'&active_token='+username+'&active_phone='+phone_number+'#/detailFault?mid='+ item.id">
                            <div class="repair_li_btn"></div>
                        </a>
                    </li>
                </ul>
                <div class="seemore">
                    <a href="http://m.hiweixiu.com/#/list">
                        <span>查看更多</span>
                    </a>
                </div>
            </div>
        </div>
        <!-- 活动说明 -->
        <div class="foot">
            <div class="des">
                <span class="des_text">——活动说明——</span>
            </div>
            <div class="des_main">
                <p>1. 本次活动时间为2019年12月03日 00:00-2019年12月12日 23:59；</p>
                <p>2. 优惠券：</p>
                <p>（1）本优惠券仅限在Hi维修手机维修项目使用，每种类型优惠券限领一张；</p>
                <p>（2）优惠券有效期至12月31日，请及时使用；</p>
                <p>（3）优惠券不能叠加使用，每笔订单只能使用1张优惠券；</p>
                <p>（4）优惠券全场维修业务通用（苹果和魅族官方授权部件除外)；</p>
                <p>3. 秒杀：</p>
                <p>（1）秒杀商品数量有限，先到先得；</p>
                <p>（2）屏幕秒杀仅限外屏故障，如需更换内屏或其他维修需按照官网价退补差价；</p>
                <p>（3）秒杀商品需在下单5分钟内进行支付，5分钟内未支付订单将自动取消；</p>
                <p>4. 参与本活动的客户，必须是有真实维修需求，Hi维修禁止客户索取配件而不维修，否则Hi维修将予以拒绝并退款；</p>
                <p>5. Hi维修在法律允许范围内拥有本活动解释权。</p>
            </div>
        </div>
        <!-- 登录模块 -->
        <loginDialog ref="loginDialog" />
    </div>
</template>
<script>
import loginDialog from "../components/loginDialog";
import tipDrawer from "../components/tipDrawer";
export default {
    components: {
        loginDialog,
        tipDrawer
    },
    data() {
        return {
            flashSaleData: [
                {
                    date: "12.03",
                    content: [
                        {
                            modelName: "iPhone 7P",
                            time: "10:00",
                            flashSalePrice: "99.9",
                            img: "images/flashsale/sale/7p10p.png",
                            OriginalPrice: "",
                            killHref:"https://j.youzan.com/hZ4QMY"
                        },
                        {
                            modelName: "iPhone 7P",
                            time: "10:00",
                            flashSalePrice: "12.12",
                            img: "images/flashsale/sale/7p17d.png",
                            OriginalPrice: "",
                            killHref:"https://j.youzan.com/hZ4QMY"
                        }
                    ]
                },
                {
                    date: "12.04",
                    content: [
                        {
                            modelName: "iPhone 7",
                            time: "10:00",
                            flashSalePrice: "59.9",
                            img: "images/flashsale/sale/710p.png",
                            OriginalPrice: "",
                            killHref:"https://j.youzan.com/hZ4QMY"
                        },
                        {
                            modelName: "iPhone 7",
                            time: "17:00",
                            flashSalePrice: "12.12",
                            img: "images/flashsale/sale/717d.png",
                            OriginalPrice: "",
                            killHref:"https://j.youzan.com/hZ4QMY"
                        }
                    ]
                },
                {
                    date: "12.05",
                    content: [
                        {
                            modelName: "iPhone X",
                            time: "10:00",
                            flashSalePrice: "129.9",
                            img: "images/flashsale/sale/x10p.png",
                            OriginalPrice: "",
                            killHref:"https://j.youzan.com/hZ4QMY"
                        },
                        {
                            modelName: "iPhone X",
                            time: "17:00",
                            flashSalePrice: "39.9",
                            img: "images/flashsale/sale/x17d.png",
                            OriginalPrice: "",
                            killHref:"https://shop41175468.m.youzan.com/wscgoods/detail/2x6pkezd9gcj8?ump_type=seckill&ump_alias=znuemmqx&activityType=seckill"
                        }
                    ]
                },
                {
                    date: "12.06",
                    content: [
                        {
                            modelName: "iPhone 6",
                            time: "10:00",
                            flashSalePrice: "39.9",
                            img: "images/flashsale/sale/610p.png",
                            OriginalPrice: "",
                            killHref:"https://shop41175468.m.youzan.com/wscgoods/detail/2oqgpp1s2pw44?ump_type=seckill&ump_alias=ror1swc1&activityType=seckill"
                        },
                        {
                            modelName: "iPhone 6",
                            time: "10:00",
                            flashSalePrice: "12.12",
                            img: "images/flashsale/sale/617d.png",
                            OriginalPrice: "",
                            killHref:"https://shop41175468.m.youzan.com/wscgoods/detail/2oqh20sp8y35w?ump_type=seckill&ump_alias=7drgg189&activityType=seckill"
                        }
                    ]
                },
                {
                    date: "12.07",
                    content: [
                        {
                            modelName: "iPhone 6P",
                            time: "10:00",
                            flashSalePrice: "39.9",
                            img: "images/flashsale/sale/6p10p.png",
                            OriginalPrice: "",
                            killHref:"https://shop41175468.m.youzan.com/wscgoods/detail/1yho5jicfby38?ump_type=seckill&ump_alias=6qx2sq9x&activityType=seckill"
                        },
                        {
                            modelName: "iPhone 6P",
                            time: "10:00",
                            flashSalePrice: "12.12",
                            img: "images/flashsale/sale/6p17d.png",
                            OriginalPrice: "",
                            killHref:"https://shop41175468.m.youzan.com/wscgoods/detail/2oqet5d6b26h0?ump_type=seckill&ump_alias=201o9app&activityType=seckill"
                        }
                    ]
                },
                {
                    date: "12.08",
                    content: [
                        {
                            modelName: "iPhone 6S",
                            time: "10:00",
                            flashSalePrice: "39.9",
                            img: "images/flashsale/sale/6s10p.png",
                            OriginalPrice: "",
                            killHref:"https://shop41175468.m.youzan.com/wscgoods/detail/35vjg4bf1wxv8?ump_type=seckill&ump_alias=3ekaq518&activityType=seckill"
                        },
                        {
                            modelName: "iPhone 6S",
                            time: "10:00",
                            flashSalePrice: "12.12",
                            img: "images/flashsale/sale/6s17d.png",
                            OriginalPrice: "",
                            killHref:"https://shop41175468.m.youzan.com/wscgoods/detail/271m1nr96eyis?ump_type=seckill&ump_alias=1brojgmh8&activityType=seckill"
                        }
                    ]
                },
                {
                    date: "12.09",
                    content: [
                        {
                            modelName: "iPhone 6SP",
                            time: "10:00",
                            flashSalePrice: "99.9",
                            img: "images/flashsale/sale/6sp10p.png",
                            OriginalPrice: "",
                            killHref:"https://shop41175468.m.youzan.com/wscgoods/detail/1ybh7vl4kl4ys?ump_type=seckill&ump_alias=sq29umpm&activityType=seckill"
                        },
                        {
                            modelName: "iPhone 6SP",
                            time: "10:00",
                            flashSalePrice: "12.12",
                            img: "images/flashsale/sale/6sp17d.png",
                            OriginalPrice: "",
                            killHref:"https://shop41175468.m.youzan.com/wscgoods/detail/367v2bzlwj14k?ump_type=seckill&ump_alias=1ia6d4s15&activityType=seckill"
                        }
                    ]
                },
                {
                    date: "12.10",
                    content: [
                        {
                            modelName: "iPhone 7P",
                            time: "10:00",
                            flashSalePrice: "99.9",
                            img: "images/flashsale/sale/7p10p.png",
                            OriginalPrice: "",
                            killHref:"https://shop41175468.m.youzan.com/wscgoods/detail/26wnyy6kxhgt0?ump_type=seckill&ump_alias=3jylo6aq&activityType=seckill"
                        },
                        {
                            modelName: "iPhone 7P",
                            time: "10:00",
                            flashSalePrice: "12.12",
                            img: "images/flashsale/sale/7p17d.png",
                            OriginalPrice: "",
                            killHref:"https://shop41175468.m.youzan.com/wscgoods/detail/1yhna9jqkocf8?ump_type=seckill&ump_alias=3n64dzli&activityType=seckill"
                        }
                    ]
                },
                {
                    date: "12.11",
                    content: [
                        {
                            modelName: "iPhone 7",
                            time: "10:00",
                            flashSalePrice: "59.9",
                            img: "images/flashsale/sale/710p.png",
                            OriginalPrice: "",
                            killHref:"https://shop41175468.m.youzan.com/wscgoods/detail/1y911yxhcbi4k?ump_type=seckill&ump_alias=1f4je2i8y&activityType=seckill"
                        },
                        {
                            modelName: "iPhone 7",
                            time: "17:00",
                            flashSalePrice: "12.12",
                            img: "images/flashsale/sale/717d.png",
                            OriginalPrice: "",
                            killHref:"https://shop41175468.m.youzan.com/wscgoods/detail/2ocv0ok70oyes?ump_type=seckill&ump_alias=1dniz94ba&activityType=seckill"
                        }
                    ]
                },
                {
                    date: "12.12",
                    content: [
                        {
                            modelName: "iPhone X",
                            time: "10:00",
                            flashSalePrice: "129.9",
                            img: "images/flashsale/sale/x10p.png",
                            OriginalPrice: "",
                            killHref:"https://shop41175468.m.youzan.com/wscgoods/detail/3eo5h9tj0a7j8?ump_type=seckill&ump_alias=1hgole4wy&activityType=seckill"
                        },
                        {
                            modelName: "iPhone X",
                            time: "17:00",
                            flashSalePrice: "39.9",
                            img: "images/flashsale/sale/x17d.png",
                            OriginalPrice: "",
                            killHref:"https://shop41175468.m.youzan.com/wscgoods/detail/2g2tg3ioe9xok?ump_type=seckill&ump_alias=16tpiosw9&activityType=seckill"
                        }
                    ]
                }
            ],
            screenData:[
                {   
                    "id":"343",
                    "img": "images/flashsale/screen/7p.png"
                },
                {
                    "id":"1160",
                    "img": "images/flashsale/screen/xp.png"
                },
                {
                    "id":"31",
                    "img": "images/flashsale/screen/6p.png"
                },
                {
                    "id":"1154",
                    "img": "images/flashsale/screen/8p.png"
                }
            ],
            batteryData:[
                {
                    "id":"343",
                    "img": "images/flashsale/battery/7d.png"
                },
                {
                    "id":"1160",
                    "img": "images/flashsale/battery/xd.png"
                },
                {
                    "id":"31",
                    "img": "images/flashsale/battery/6d.png"
                },
                {
                    "id":"1154",
                    "img": "images/flashsale/battery/8d.png"
                }
            ],
            curDateIndex: 0,
            showthis: false,
            showtext: "",
            // 领取优惠券状态
            canGetCoupon:true,
            phone_number:"",
            username:"",
            // ref 参数
            ref:'',

        };
    },
    watch:{
        phone_number(){
            this.checkCoupon()
        }
    },
    methods: {
        chooseDate(index) {
            this.curDateIndex = index;
        },
        // 判断是否是隐身模式
        storageTest() {
            var storage = window.localStorage;
            storage.setItem("key", "value");
            if (storage.getItem("key") == "value") {
                return true;
            } else {
                return false;
            }
        },
        // 获取localStorage
        getLocalStorage(key) {
            if (this.storageTest()) {
                return localStorage.getItem(key);
            } else {
                return sessionStorage.getItem(key);
            }
        },
        // 存localStorage或者sessionStorage
        writeStorage(key, value) {
            localStorage.setItem(key, value);
            if (this.storageTest()) {
                localStorage.setItem(key, value);
            } else {
                sessionStorage.setItem(key, value);
            }
        },
        getcoupon() {
            if (
                this.getLocalStorage("tel") &&
                this.getLocalStorage("username")
            ) {
                console.log("请求领取优惠券接口");
                //  请求领取优惠券接口
                this.ajaxCoupon();
            } else {
                this.$refs.loginDialog.loginShow = true;
                console.log("登录");
            }
        },
        ajaxCoupon() {
            let postData = {
                phone_number: this.getLocalStorage("tel"),
                source:1,
                batch_list:JSON.stringify([
                    "201911281352414802",
                    "201911281353257130",
                    "201911281353578106"
                ])
            };
            var that = this;
            console.log(postData);
            $.ajax({
                type: "POST",
                url:
                    "//userapi.hiweixiu.com/wwwapi/v1/promotion/h5/coupons/multi-coupon-collect?token=" +
                    this.getLocalStorage("username"),
                data: postData,
                success: function(res) {
                    console.log(res)
                    if (res.code == 200) {
                        this.showthis = true;
                        this.showtext = res.msg;
                    } else {
                        this.showthis = true;
                        this.showtext = res.msg;
                    }
                },
                error: function(e) {
                    console.log(e);
                    if(e.responseJSON.code == 401){
                        that.writeStorage("username", "");
                        that.writeStorage("tel", "");
                        
                    }
                    return false;
                }
            });
            this.checkCoupon();
        },
        checkCoupon(){
            let postData = {
                phone_number: this.getLocalStorage("tel"),
                batch_list:JSON.stringify([
                    "201911281352414802",
                    "201911281353257130",
                    "201911281353578106"
                ])
            };
            var that = this;
            console.log(postData);
            $.ajax({
                type: "POST",
                url:
                    "//userapi.hiweixiu.com/wwwapi/v1/promotion/h5/coupons/get-multi-coupon-info?token=" +
                    this.getLocalStorage("username"),
                data: postData,
                success: function(res) {
                    if (res.code == 200) {
                       if(res.data.user_status == 0){
                           that.canGetCoupon = false;
                       }
                    } else {

                    }
                },
                error: function(e) {
                    console.log(e);
                    if(e.responseJSON.code == 401){
                        that.writeStorage("username", "");
                        that.writeStorage("tel", "");

                    }
                    return false;
                }
            });
        },
        // 获取ref参数
        getParam(paramName) {
            var paramValue = "",
                isFound = !1;
            if (
                location.search.indexOf("?") == 0 &&
                location.search.indexOf("=") > 1
            ) {
                var arrSource = unescape(location.search)
                        .substring(1, location.search.length)
                        .split("&"),
                    i = 0;
                while (i < arrSource.length && !isFound)
                    arrSource[i].indexOf("=") > 0 &&
                        arrSource[i].split("=")[0].toLowerCase() ==
                            paramName.toLowerCase() &&
                        ((paramValue = arrSource[i].split("=")[1]),
                        (isFound = !0)),
                        i++;
            }
            return paramValue == "" && (paramValue = null), paramValue;
		},
    },
    mounted() {
        var myDate = new Date();
        var myYear = myDate.getFullYear(); // 获取当前年份
        var myMonth = myDate.getMonth() + 1; // 获取当前月份
        var myDay = myDate.getDate(); // 获取当前日（1- 31）
        // var myMonth =12; // 获取当前月份
        // var myDay = 12; // 获取当前日（1- 31）
        console.log(myYear);
        console.log(myMonth);
        console.log(myDay);
        if (myMonth == 12) {
            if (myDay > 2 && myDay < 13) {
                this.curDateIndex = myDay - 3;
            } else {
                this.curDateIndex = 0;
            }
        } else {
            this.curDateIndex = 0;
        }
        this.checkCoupon();
        this.ref = this.getParam("ref");
    }
};
</script>
<style lang="scss" scoped>
.flashsale_container {
    width: 100%;
    background: #c62217;
    padding-bottom: 30px;
    .top_banner {
        width: 100%;
        .top_img {
            width: 100%;
            img {
                width: 100%;
            }
        }
    }
    .title_img {
        width: 100%;
        height: 74px;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
            height: 38px;
        }
    }
    .flashsale_main {
        .flashsale_main_body {
            padding: 0 14px;
            width: 100%;
            border-radius: 5px;
            box-sizing: border-box;
            .flashsale_main_body_linear {
                width: 100%;
                width: 100%;
                border-radius: 5px;
                background: linear-gradient(
                    -63deg,
                    rgba(200, 36, 25, 1),
                    rgba(250, 114, 78, 1)
                );
            }
            .date_main {
                padding-top: 6px;
                padding-left: 6px;
                .date_li {
                    width: 65px;
                    height: 42px;
                    color: #ffaba1;
                    font-size: 14px;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    text-align: center;
                    line-height: 42px;
                    margin: 0 1px;
                    &.active {
                        background: url(../assets/flashsaleimg/dateactive.png)
                            center no-repeat;
                        background-size: 75px 42px;
                        color: #931d0e;
                    }
                }
            }
            .model_main {
                width: 100%;
                .model_li {
                    width: 100%;
                    .model_img {
                        width: 100%;
                        img {
                            width: 100%;
                        }
                    }
                }
            }
        }
    }
    .user_coupon {
        width: 100%;
        padding: 0 14px;
        margin-top: 18px;
        img {
            width: 100%;
        }
    }
    .repair {
        .repair_mian {
            margin: 0 9px;
            .repair_li {
                position: relative;
                width: 170px;
                height: 241px;
                margin: 6px 4px;
                img {
                    width: 170px;
                    height: 213px;
                }
                .repair_li_btn {
                    position: absolute;
                    bottom: 0;
                    left: 14px;
                    height: 52px;
                    width: 143px;
                    background: url(../assets/flashsaleimg/repairbtn.png) center
                        no-repeat;
                    background-size: 143px 52px;
                }
            }
        }
        .seemore {
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            span {
                display: inline-block;
                height: 21px;
                font-size: 14px;
                font-family: Source Han Sans CN;
                font-weight: 500;
                line-height: 10px;
                border-bottom: 1px solid #fff;
                color: rgba(255, 255, 255, 1);
            }
        }
    }
    .foot {
        .des {
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 18px 0;
            .des_text {
                font-size: 18px;
                font-family: Source Han Sans CN;
                color: #fff;
            }
        }
        .des_main {
            margin: 0 14px;
            color: #fff;
            line-height: 23px;
            font-size: 12px;
            font-family: Source Han Sans CN;
        }
    }
}
</style>
